export default __webpack_public_path__ + "static/media/gp-dropdown.1df3f3b8.webp";